// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CallPermissionsPopup__wrapper-de214c {
  overflow-y: auto;
}

.CallPermissionsPopup__component-d40a57 {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.CallPermissionsPopup__list-e34e6d {
  display: flex;
  flex-direction: column;
  margin-top: 12px;
}

.CallPermissionsPopup__blockName-eeb41f {
  font: var(--font-subtitle-1);
  color: var(--base-80);
  margin: 16px 24px 0 24px;
  letter-spacing: var(--font-spacing-subtitle-1);
}

.CallPermissionsPopup__block-divider-a66e09 {
  width: 100%;
  height: 12px;
  margin: 10px 0;
  background-color: var(--base-15);
}

.CallPermissionsPopup__divider-f3665e {
  height: 1px;
  width: 100%;
  margin: 32px 24px 0 24px;
  background: var(--base-20);
}

.CallPermissionsPopup__overlaying-popup-ae5b13 {
  padding: 0;
}

.CallPermissionsPopup__popup-a3479c {
  max-width: 440px;
  width: 100%;
}

.CallPermissionsPopup__mobile-border-af5c9b {
  border-radius: 0;
}`, "",{"version":3,"sources":["webpack://./../../packages/call/src/popups/Permissions/CallPermissionsPopup/CallPermissionsPopup.styles.m.css"],"names":[],"mappings":"AAAA;EACE,gBAAA;AACF;;AACA;EACE,OAAA;EACA,aAAA;EACA,sBAAA;AAEF;;AACA;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;AAEF;;AACA;EACE,4BAAA;EACA,qBAAA;EACA,wBAAA;EACA,8CAAA;AAEF;;AACA;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,gCAAA;AAEF;;AACA;EACE,WAAA;EACA,WAAA;EACA,wBAAA;EACA,0BAAA;AAEF;;AACA;EACE,UAAA;AAEF;;AACA;EACE,gBAAA;EACA,WAAA;AAEF;;AACA;EACE,gBAAA;AAEF","sourcesContent":[".wrapper {\n  overflow-y: auto;\n}\n.component {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n}\n\n.list {\n  display: flex;\n  flex-direction: column;\n  margin-top: 12px;\n}\n\n.blockName {\n  font: var(--font-subtitle-1);\n  color: var(--base-80);\n  margin: 16px 24px 0 24px;\n  letter-spacing: var(--font-spacing-subtitle-1);\n}\n\n.block-divider {\n  width: 100%;\n  height: 12px;\n  margin: 10px 0;\n  background-color: var(--base-15);\n}\n\n.divider {\n  height: 1px;\n  width: 100%;\n  margin: 32px 24px 0 24px;\n  background: var(--base-20);\n}\n\n.overlaying-popup {\n  padding: 0;\n}\n\n.popup {\n  max-width: 440px;\n  width: 100%;\n}\n\n.mobile-border {\n  border-radius: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `CallPermissionsPopup__wrapper-de214c`,
	"component": `CallPermissionsPopup__component-d40a57`,
	"list": `CallPermissionsPopup__list-e34e6d`,
	"blockName": `CallPermissionsPopup__blockName-eeb41f`,
	"block-divider": `CallPermissionsPopup__block-divider-a66e09`,
	"blockDivider": `CallPermissionsPopup__block-divider-a66e09`,
	"divider": `CallPermissionsPopup__divider-f3665e`,
	"overlaying-popup": `CallPermissionsPopup__overlaying-popup-ae5b13`,
	"overlayingPopup": `CallPermissionsPopup__overlaying-popup-ae5b13`,
	"popup": `CallPermissionsPopup__popup-a3479c`,
	"mobile-border": `CallPermissionsPopup__mobile-border-af5c9b`,
	"mobileBorder": `CallPermissionsPopup__mobile-border-af5c9b`
};
module.exports = ___CSS_LOADER_EXPORT___;
